<template>
  <RCard class="email">
    <AgGrid :options="gridOptions" :row-data="emails" @ready="agGrid = $event">
      <template #header>
        <Grid gaf="column" justify-content="space-between" class="q-mb-xs">
          <div class="text-subtitle-1 text-secondary-2 q-ml-sm q-mt-sm">Emails</div>

          <RInput v-model="search" placeholder="search list" is-search no-hint no-label no-feedback-icon />
        </Grid>
      </template>
    </AgGrid>

    <EmailModal ref="modal" />
  </RCard>
</template>

<script>
import { createdAtSorter } from '@lib/generic.utils'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import AttachmentCell from '@/ag-grid/components/attachment-cell/AttachmentCell'
import EmailModal from '@/reusable/EmailModal'

export default {
  components: {
    AgGrid,
    EmailModal
  },

  props: {
    emails: Array
  },

  data() {
    return {
      search: null,
      agGrid: null
    }
  },

  computed: {
    gridOptions() {
      let columnDefs = [
        {
          headerName: 'Date/Time',
          field: 'created_at',
          comparator: createdAtSorter,
          cellRenderer: params => this.formatDateTimeForLocale(params.value),
          getQuickFilterText: params => this.formatDateTimeForLocale(params.value),
          sort: 'asc',
          type: 'centerAligned'
        },
        {
          headerName: 'Subject',
          field: 'subject',
          cellRendererParams: {
            onClick: this.openModal
          },
          cellRendererFramework: 'LinkRenderer'
        },
        {
          headerName: 'Sent by',
          field: 'from'
        },
        {
          headerName: 'Sent to',
          field: 'to'
        },
        {
          headerName: 'File(s)',
          field: 'has_attachments',
          cellRendererFramework: AttachmentCell,
          getQuickFilterText: () => null,
          width: 54,
          maxWidth: 54
        }
      ]
      return {
        columnDefs,
        defaultColDef: {
          resizable: false,
          floatingFilter: false
        },
        domLayout: 'autoHeight'
      }
    }
  },

  watch: {
    search(newVal) {
      this.agGrid.api.setQuickFilter(newVal)
    }
  },

  methods: {
    openModal(row) {
      this.$refs.modal.show(row.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.email {
  @include table-with-no-filters;
}
</style>
